import PulseOximeter from './PulseOximeter';

export default PulseOximeter;
